// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

// required for modal close
// but makes problem with showing calendar when is on
// dodat u a tag ukoliko treba iskljucit turbolinks na neki klick
// data-turbolinks="false"

// require("flatpickr/dist/themes/airbnb.css")
require('../css/flatpickr.min');

require('datatables.net');
require('datatables.net-bs4');
require('datatables.net-bs4/css/dataTables.bootstrap4.min.css');

// import flatpickr from "flatpickr";
var flatpickr = require('../js/flatpickr');
global.$ = global.flatpickr = flatpickr;
window.$ = window.flatpickr = flatpickr;

import ColorThief from '../js/color-thief.umd';
import '../css/public_layout.scss';

// import Swiper from "swiper";
var Swiper = require('../js/swiper-bundle.min');
global.$ = global.Swiper = Swiper;
window.$ = window.Swiper = Swiper;

var jQuery = require('jquery');

global.$ = global.jQuery = jQuery;
window.$ = window.jQuery = jQuery;
import 'bootstrap';

require('@rails/ujs').start();
require('./general');

// import flatpickr from "flatpickr";

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

const images = require.context('../images', true);
const imagePath = (name) => images(name, true);

const colorThief = new ColorThief();

function resizeContent3() {
  setTimeout(function () {
    var swiper = null;
    if ($(window).width() > 960) {
      swiper = new Swiper('.swiper-container', {
        direction: 'horizontal',
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        scrollbar: {
          el: '.swiper-scrollbar',
          hide: true,
        },
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        // breakpoints: {
        //   1024: {
        //     slidesPerView: 1,
        //     spaceBetween: 15
        //   },
        //   768: {
        //     slidesPerView: 1,
        //     spaceBetween: 15
        //   },
        //   640: {
        //     slidesPerView: 1,
        //     spaceBetween: 15
        //   },
        //   // 320: {
        //   //   slidesPerView: 1.20,
        //   //   spaceBetween: 0
        //   // }
        // },
      });
    }
  }, 100);
}

function initSwipers() {
  if (document.querySelector('.event-thumbs')) {
    new Swiper('.event-thumbs', {
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  }

  if (document.querySelector('.single-mode')) {
    new Swiper('.single-mode', {
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  }
}

$(document).on('turbolinks:load', function () {
  flatpickr('.datepicker', {
    enableTime: true,
    format: 'mm/dd/yyyy',
    defaultDate: 'today',
  });

  resizeContent3();
  initSwipers();

  var img = document.querySelector('.venue_featured_image');

  var dominantColor;

  // Make sure image is finished loading
  if (img !== null && img.complete) {
    dominantColor = colorThief.getColor(img);
  } else if (img !== null) {
    img.addEventListener('load', function () {
      dominantColor = colorThief.getColor(img);
    });
  }

  var gradient_container = document.querySelector('.gradient-container');

  if (gradient_container && dominantColor) {
    $(gradient_container).css({
      'background-image': `linear-gradient(180deg, rgba(${dominantColor.join()},.9), rgba(255,0,0,0) 100%)`,
      height: '600px',
      'padding-top': '2rem',
    });
  }
});
